import Loader from "react-loader-spinner";
import { Alert, Button, Col, Form, FormGroup, Modal, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCity, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProvinces, getCityList, getZoneList, addOrUpdateCity, addOrUpdateZone, deleteCity, deleteZone } from "../store/api/LocationAPI";
import { setDialog, setErrorDialog, translateError } from "../../store/api/CommonFunctions";
import { Check2Square, DashCircle, ExclamationTriangle, ExclamationTriangleFill, PencilFill, PlusSquare, Trash, Trash2 } from "react-bootstrap-icons";

export default function ModalAddEditLocation(props) {
    const { popData, setPopData } = props;
    const { show } = popData;
    const dispatch = useDispatch();
    const inputProvince = useRef();
    const currentCityID = useRef();
    const [currentCity, setCurrentCity] = useState();
    const [currentZone, setCurrentZone] = useState();
    const [submitError, setSubmitError] = useState();
    const { provinceList, cityList, zoneList } = useSelector(state => {
        return {
            provinceList: state.locationDataReducer?.provinceList,
            cityList: state.locationDataReducer?.cityList,
            zoneList: state.locationDataReducer?.zoneList
        }
    })
    function close() {
        setPopData({ show: false });
    }
    function onProvinceSelect(e) {
        const id = e.target.value;
        dispatch(getCityList(id));
    }
    function onCitySelect(e, city) {
        if (e?.target?.tagName?.toLowerCase() !== "td" || currentCity) {
            return;
        }
        currentCityID.current = city.Id;
        const tr = e.target.closest(".resultTableRow");
        const tableBody = tr.parentElement;
        tableBody.querySelectorAll(".selectedResultTableRow").forEach(el => el.classList.remove("selectedResultTableRow"));
        if (tr) {
            tr.classList.add("selectedResultTableRow");
        }
        dispatch(getZoneList(city?.Id));
    }
    function prepareCityForEdit(city) {
        if (city?.Id) {
            delete city.e;
            setCurrentCity(city);
        }
    }
    function prepareCityForAdd() {
        setCurrentCity({ Id: 0 });
    }
    function cancelCity() {
        setCurrentCity(null);
    }
    function submitCity() {

        if ((currentCity.Name ?? "") === "") {
            setSubmitError("نام شهر وارد نشده است.");
            return;
        }
        currentCity.ProvinceId = inputProvince.current.value;
        const onAddUpdate = (res) => {
            if (res.Error) {
                setSubmitError(translateError(res.Error));
            }
            else {
                setCurrentCity(null);
            }
        }
        dispatch(addOrUpdateCity(currentCity, onAddUpdate));
    }
    function deleteC(city) {
        const onDelete = (res) => {
            if (res.Error) {
                setSubmitError(res.Error);
            }
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف شهر',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: () => dispatch(deleteCity(city.Id, onDelete))
        }));
    }
    function prepareZoneForEdit(zone) {
        if (zone?.Id) {
            delete zone.e;
            setCurrentZone(zone);
        }
    }
    function prepareZoneForAdd() {
        setCurrentZone({ Id: 0 });
    }
    function cancelZone() {
        setCurrentZone(null);
    }
    function submitZone() {
        if ((currentZone?.Name ?? "") === "") {
            setSubmitError("نام منطقه جغرافیایی وارد نشده است.");
            return;
        }
        currentZone.CityId = currentCityID.current;
        const onSubmit = (res) => {
            if (res.Error) {
                setSubmitError(res.Error);
            }
            else {
                setCurrentZone(null);
            }
        }
        dispatch(addOrUpdateZone(currentZone, onSubmit));
    }
    function deleteZ(zone) {
        const onDelete = (res) => {
            if (res.Error) {
                setErrorDialog(res.Error);
            }
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف شهر',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: () => dispatch(deleteZone(zone.Id, onDelete))
        }));

    }
    useEffect(() => {
        if (show && !provinceList || !Array.isArray(provinceList) || provinceList.length === 0) {
            dispatch(getAllProvinces());
        }
    }, [show])
    return (
        <Modal show={show} size="lg" onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCity} size="lg" />&nbsp;مدیریت مناطق جغرافیایی
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {submitError &&
                    <Alert variant="danger"><span>
                        <ExclamationTriangleFill color="orange" size={23} />&nbsp;{submitError}</span>
                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                    </Alert>
                }
                <FormGroup style={{ width: "50%" }}>
                    {provinceList === "PENDING" &&
                        <div className="form-control">
                            <Loader type="BallTriangle" color="#bb1370" width={20} height={20} style={{ display: "inline-block" }} />&nbsp;
                            در حال بارگذاری فهرست
                        </div>}
                    {Array.isArray(provinceList) &&
                        <select className="form-control" onChange={onProvinceSelect} ref={inputProvince}>
                            <option value="">استان را انتخاب کنید</option>
                            {provinceList.map((prv, i) => <option key={i} value={prv.Id}>{prv.Name}</option>)}
                        </select>
                    }
                </FormGroup>
                <Row className="mt-1 rowBorder" style={{ paddingTop: "5px" }}>
                    <Col>
                        <Button className="group-Btn-smalll mb-1" onClick={prepareCityForAdd}><PlusSquare size={23} /></Button>
                        <Table responsive className="fixedHeightTable mb-0 ">
                            <thead>
                                <tr >
                                    <th style={{ position: "sticky", top: 0, zIndex: 150, backgroundColor: "#b6b6b6" }}>نام شهر</th>
                                    <th style={{ position: "sticky", top: 0, zIndex: 150, backgroundColor: "#b6b6b6", width: "80px" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(cityList) &&
                                    cityList.map((item, i) =>
                                        <tr key={i} className="resultTableRow" onClick={(e) => onCitySelect(e, item)}>
                                            <td value={item.Id}>{item.Name}</td>
                                            <td>
                                                <PencilFill color="orange" onClick={() => prepareCityForEdit(item)} size={18} className="rowBtn" />&nbsp;
                                                <Trash color="red" onClick={() => deleteC(item)} size={18} className="rowBtn" />
                                            </td>
                                        </tr>)
                                }
                            </tbody>
                        </Table>
                        {currentCity &&
                            <FormGroup>
                                <Form.Control defaultValue={currentCity.Name ?? ""} onChange={e => currentCity.Name = e.target.value} />
                                <Button variant="info" className="btn-input-tiny" onClick={submitCity} style={{ top: 2, left: 37 }}><Check2Square size={23} /></Button>
                                <Button variant="danger" className="btn-input-tiny" onClick={cancelCity} style={{ top: 2, left: 2 }}><DashCircle size={23} /></Button>
                            </FormGroup>
                        }
                    </Col>
                    <Col>
                        <Button className="group-Btn-smalll mb-1" onClick={prepareZoneForAdd}><PlusSquare size={23} /></Button>
                        <Table>
                            <thead>
                                <tr>
                                    <th style={{ position: "sticky", top: 0, zIndex: 150, backgroundColor: "#b6b6b6" }}>نام منطقه</th>
                                    <th style={{ position: "sticky", top: 0, zIndex: 150, backgroundColor: "#b6b6b6" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(zoneList) &&
                                    zoneList.map((item, i) =>
                                        <tr key={i} className="resultTableRow">
                                            <td value={item.Id} >{item.Name}</td>
                                            <td>
                                                <PencilFill color="orange" onClick={() => prepareZoneForEdit(item)} size={18} className="rowBtn" />&nbsp;
                                                <Trash color="red" onClick={() => deleteZ(item)} size={18} className="rowBtn" />
                                            </td>
                                        </tr>)
                                }
                            </tbody>
                        </Table>
                        {currentZone &&
                            <FormGroup>
                                <Form.Control defaultValue={currentZone.Name ?? ""} onChange={e => currentZone.Name = e.target.value} />
                                <Button variant="info" className="btn-input-tiny" onClick={submitZone} style={{ top: 2, left: 37 }}><Check2Square size={23} /></Button>
                                <Button variant="danger" className="btn-input-tiny" onClick={cancelZone} style={{ top: 2, left: 2 }}><DashCircle size={23} /></Button>
                            </FormGroup>
                        }
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}